export const ROLE_LABELS = {
  agency_admin: "Admin Agenzia",
  agency_operator: "Operatore Agenzia",
  partner_broker: "Broker",
  partner_subagente: "Subagente",
  partner_produttore: "Produttore",
  partner_collab_AA: "Collaboratore A-A",
  partner_collab_AB: "Collaboratore A-B",
};

export const PARTNER_ROLE_OPTIONS = [
  { value: "partner_broker", label: "Broker (A con B)" },
  { value: "partner_subagente", label: "Subagente" },
  { value: "partner_produttore", label: "Produttore" },
  { value: "partner_collab_AA", label: "Collaboratore A con A" },
  { value: "partner_collab_AB", label: "Collaboratore A con B" },
];

export const STATE_META = {
  richiesta: { label: "Richiesta", tone: "info" },
  bozza: { label: "Bozza", tone: "muted" },
  preventivo_emesso: { label: "Preventivo emesso", tone: "brand" },
  autorizzato: { label: "Autorizzato", tone: "brand" },
  accettato_cliente: { label: "Accettato dal cliente", tone: "brand" },
  in_attesa_bonifico: { label: "In attesa bonifico", tone: "warning" },
  pagato: { label: "Pagato", tone: "success" },
  polizza_emessa: { label: "Polizza emessa", tone: "success" },
  perfezionato: { label: "Perfezionato", tone: "success" },
  non_perfezionato: { label: "Non perfezionata", tone: "error" },
  referral_inviato: { label: "Referral inviato", tone: "warning" },
  referral_rifiutato: { label: "Referral rifiutato", tone: "error" },
  in_autorizzazione: { label: "In Autorizzazione", tone: "warning" },
};

// Stato "effettivo" mostrato al partner: un preventivo in referral tecnico non ancora
// evaso dall'Agenzia viene mostrato come "In Autorizzazione" (non come semplice "Bozza").
export function effectiveQuoteState(q) {
  if (!q) return undefined;
  if (q.binario === "referral_tecnico" && ["bozza", "referral_inviato"].includes(q.stato)) {
    return "in_autorizzazione";
  }
  return q.stato;
}

export const ADMIN_STATE_OPTIONS = [
  "bozza", "preventivo_emesso", "autorizzato", "accettato_cliente", "in_attesa_bonifico",
  "pagato", "polizza_emessa", "perfezionato", "non_perfezionato", "referral_rifiutato",
];

export const CLUSTERS = ["ODV / APS", "Cooperativa sociale", "Parrocchia / Ente religioso", "ASD / SSD sportiva", "Altro ETS"];

export const SLIDER_MIN = -10;
export const SLIDER_MAX = 300;

// Sconto massimo (slider negativo) per ruolo: Assietica diretta core (Admin + collab A-A
// Mauro/Umberto) può scontare fino al 20% in autonomia; gli altri fino al 10% (con referral).
export const CORE_DISCOUNT_ROLES = ["agency_admin", "partner_collab_AA"];
export function sliderMinFor(role) {
  return CORE_DISCOUNT_ROLES.includes(role) ? -20 : -10;
}
